/**
 * A drop-down button control.
 *
 * ## Events
 * Name | Arguments | Description
 * click | A reference to `this` view, the original event, and the index of the entry that was clicked. | Fired when any of the options is selected.
 * @module app/views/DropdownButtonView
 */
import Backbone from "backbone";
import _ from "underscore";
import $ from "jquery";
var DropdownButtonView = Backbone.View.extend({
  className: "btn-group",
  attributes: {
    type: "button",
  },

  template: _.template(
    '<button type="button" class="btn btn-<%-type%> dropdown-toggle" data-toggle="dropdown"><%-text%> <span class="caret"></span></button><ul class="dropdown-menu" role="menu"><% _.each(options, function(option, idx){%><li><a href="#" data-index="<%- idx%>"><%-option.text%></a></li><%})%></ul>'
  ),

  events: {
    "click a": function (evt) {
      var idx = $(evt.target).data("index");

      this.trigger("click", this, evt, idx);
      this.options.options[idx].click(this, evt);
      evt.preventDefault();
    },
  },

  /**
   * Initializes the control.
   * @param  {object} options The options hash.
   * @param {string} options.type:'default' The theme for the control. One of `'default'`, `'primary'`, `'success'`, `'info'`, `'warning'`, `'danger'`, `'link'`.
   * @param {string} options.text:'Click' The label for the main button.
   * @param {Array} options.options The array of drop-down options.
   * @param {Function} options.options[].click The function to execute when the option is selected. Provided with a reference to `this` view and the original event.
   * @param {string} options.options[].text The label for the option.
   */
  initialize: function (options) {
    this.options = _.defaults({}, options, {
      type: "default",
      text: "Click",
      options: [
        /*{click: function(){}, text: null}*/
      ],
    });
  },
  render: function () {
    this.$el.html(this.template(this.options));
    this.$(".dropdown-toggle").dropdown();

    return this;
  },

  /**
   * Enable the button.
   */
  enable: function () {
    this.$(".btn").removeAttr("disabled");
  },

  /**
   * Disable the button.
   */
  disable: function () {
    this.$(".btn").attr("disabled", "disabled");
  },
});

export default DropdownButtonView;



//////////////////
// WEBPACK FOOTER
// ./public/js/core/views/DropdownButtonView.js
// module id = 950
// module chunks = 1